var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderSupervised = function SvgFolderSupervised(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "folder_supervised_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#folder_supervised_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5H9.05q.362 0 .695.14.334.141.58.387L11.798 6.5h7.894q.758 0 1.283.525t.525 1.283V9.87q0 .412-.344.617a.75.75 0 0 1-.731.035 6 6 0 0 0-1.27-.392A7 7 0 0 0 17.822 10q-2.873 0-4.804 2.005-1.93 2.004-1.93 4.74 0 .435.053.86.052.423.168.835.105.412-.12.736a.71.71 0 0 1-.613.324zm10.634 0a.73.73 0 0 1-.534-.215.73.73 0 0 1-.216-.535q0-.697.985-1.224.984-.526 2.67-.526 1.684 0 2.668.526t.985 1.224a.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215zm1.665-4.318q-.51-.51-.51-1.24 0-.729.51-1.239t1.24-.51 1.238.51q.51.51.511 1.24 0 .727-.51 1.239-.51.51-1.24.51-.729 0-1.24-.51"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderSupervised);
export default ForwardRef;